const apiBase = process.env.REACT_APP_API_ENDPOINT;
export { apiBase };
